import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/contexts/auth-context';
import { TenantProvider } from '@/contexts/tenant-context';
import { SyncProvider } from '@/contexts/sync-context';
import { Toaster } from '@/components/ui/sonner';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <SyncProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </SyncProvider>
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
